export default __webpack_public_path__ + "static/media/icon_share_facebook.c777682e.svg";